document.addEventListener("DOMContentLoaded", () => {
  const form = document.querySelector("#contact-form");
  form?.addEventListener("submit", async (e) => {
    e.preventDefault();

    const formResponse = form.querySelector(".form__response");
    const formSubmit = form.querySelector(".form__submit");

    // reset
    form.classList.remove("form--success", "form--error");
    formResponse.innerHTML = "";
    formSubmit.disabled = true;
    form
      .querySelectorAll('.form__field div[role="alert"]')
      .forEach((field) => (field.innerHTML = ""));

    try {
      const res = await fetch(
        battcon_global.site_url + "/wp-json/api/v1/contact",
        {
          method: "POST",
          body: new FormData(e.target),
        }
      );

      const result = await res.json();
      if (result.success) {
        form.classList.add("form--success");
        form.reset();
      } else {
        form.classList.add("form--error");
        for (const [name, errorMessage] of Object.entries(result.errors)) {
          const errorElement = form.querySelector(
            `input[name="${name}"] ~ div[role='alert'], textarea[name="${name}"] ~ div[role='alert']`
          );
          if (errorElement) {
            errorElement.innerHTML = errorMessage;
          }
        }
      }

      formResponse.innerHTML = result.message;
    } catch (error) {
      form.classList.add("form--error");
      formResponse.innerHTML =
        "An error occurred while sending the message. Please try again later.";
    } finally {
      formSubmit.disabled = false;
    }
  });
});
